<template>
  <div class="jianmeng-experience-card">
    <NavBar :placeholder="true" title="新人专享福利" />
    <div class="bg-container">
      <img
        class="bg"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-06/1cebfc1baadf1b634760a1f4547d2b34_wh=1504_2924.webp"
        alt=""
      />
      <!-- <video
        class="video"
        :controls="controls"
        muted
        :src="videoUrl"
        :poster="videoPosterUrl"
        ref="video"
        id="video"
        @click="bindClickVideo"
        type="video/mp4"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        playsinline="true"
        x5-playsinline
        autoplay="true"
        preload="auto"
      ></video> -->
    </div>
    <img
      class="btn"
      @click="bindClick"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-06/0a5af6eac9dfe16f3eff366cec059aff_wh=1276_232.webp"
      alt=""
    />
    <van-popup v-model="showPop" class="my-popup">
      <div class="pop-container">
        <img class="qrcode-image" :src="qrcodeUrl" alt="" />
        <img
          class="pop-btn"
          @click="bindSaveImage"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-02/f00d52745d707227abb25932cb9a09d5_wh=382_92.webp"
          alt=""
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import NavBar from '@/components/app/nav-bar/index.vue'
export default {
  components: { NavBar },
  data() {
    return {
      controls: false,
      qrcodeUrl:
        'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-06/941ab2da8930929296a643a242194d4a_wh=1212_1620.webp',
      showPop: false,
      videoUrl:
        'https://gymvue.gymcity.com.cn/betterwe_app/%E6%9D%8E%E8%8B%A5%E5%BD%A4ID.mp4',
      videoPosterUrl:
        'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-02/e5aabae09e1c82a0d9d9dc8b9ac2aec1_wh=1300_736.webp'
    }
  },
  created() {},
  mounted() {
    //this.init()
  },
  methods: {
    bindClickVideo() {
      this.controls = true
    },
    init() {
      let el = this.$refs.video
      el.addEventListener('loadedmetadata', () => {
        this.vieoLoaded = true
      })
      window.onPagePaused = () => {
        this.$refs.video.pause()
      }
    },
    bindClick() {
      this.showPop = true
      // location.href = 'https://work.weixin.qq.com/ca/cawcdec0299443f011?customer_channel=qywx_ca:107715923'
    },
    bindSaveImage() {
      this.$betterwe.onAppSaveImage({
        data: this.qrcodeUrl, //分享的具体数据
        //分享的数据的格式
        //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url'
      })
      this.showPop = false
    },
    isiOS() {
      return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
    handlePlayVideo() {
      if ((!this.vieoLoaded && !this.isiOS) || this.isPlay) {
        return
      }
      let el = this.$refs.video
      if (el.paused) {
        el.play()
          .then(() => {
            this.isPlay = true
          })
          .catch(() => {
            this.isPlay = false
          })
      } else {
        this.isPlay = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.jianmeng-experience-card {
  // background-color: rgb(255, 43, 112);
  min-height: 100vh;
  box-sizing: border-box;
  // padding-bottom: 80px;
  background-color: #e0e0e0;
  .bg {
    width: 100%;
  }

  .btn {
    position: fixed;
    width: 350px;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 20px;
  }

  .bg-container {
    position: relative;

    .video {
      border-radius: 2px;
      position: absolute;
      width: 326px;
      height: 184px;
      left: 50%;
      top: 177px;
      transform: translateX(-50%);
      border-radius: 4px;
    }
  }

  .pop-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .qrcode-image {
      width: 303px;
      margin-bottom: 40px;
    }

    .pop-btn {
      width: 191px;
    }
  }
}

.my-popup {
  background-color: transparent;
}
</style>
